import { render, staticRenderFns } from "./DadosAcesso.vue?vue&type=template&id=5f262d7e&scoped=true"
import script from "./DadosAcesso.vue?vue&type=script&lang=js"
export * from "./DadosAcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f262d7e",
  null
  
)

export default component.exports